import React from 'react';
import { useSelector } from 'react-redux';
import MDTypography from 'components/MDTypography';
import { AnnouncementsWrapper, TypographyText } from 'components/Ui/styled';
import FiberManualRecordRoundedIcon from '@mui/icons-material/FiberManualRecordRounded';

const Tags = () => {
  const notesInformation = useSelector((state) => state.studentDetails?.item);

  return (
    <>
      {notesInformation?.tags?.map((item, index) => {
        return (
          <AnnouncementsWrapper key={index}>
            <MDTypography variant='body1' color='secondary' lineHeight={0.75}>
              <FiberManualRecordRoundedIcon />
            </MDTypography>
            <TypographyText>{item}</TypographyText>
          </AnnouncementsWrapper>
        );
      })}
    </>
  );
};

export default Tags;
